export enum YieldState {
  Initial = 'initial',
  InitialApproving = 'initial:approving',
  InitialRejected = 'initial:rejected',
  GuaranteeApproved = 'guarantee:approved',
  GuaranteeApproving = 'guarantee:approving',
  GuaranteeRejected = 'guarantee:rejected',
  WarrantyApproved = 'warranty:approved',
}

export enum YieldFileState {
  Pending = 'pending',
  Processing = 'processing',
  Ok = 'ok',
  Failed = 'failed'
}

export enum YieldFileType {
  GuaranteePvSystData = 'guarantee:pvsyst-data',
  GuaranteePvSystReport = 'guarantee:pvsyst-report',
  GuaranteeCalculationSummary = 'guarantee:calculations',
  GuaranteeAssumptionsReport = 'guarantee:assumptions',

  ConsumptionPvSystReport = 'consumption:pvsyst-report',
  ConsumptionCalculationSummary = 'consumption:calculations',
  ConsumptionAssumptionsReport = 'consumption:assumptions',

  WarrantyExitDraw = 'warranty:exit-draw'
}

export enum YieldAction {
  GuaranteeApproval = 'guarantee:approval',
  GuaranteeRejection = 'guarantee:rejection',
  WarrantyApproval = 'warranty:approval',
  WarrantyRejection = 'warranty:rejection',
  ConsumptionApproval = 'consumption:approval',
  ConsumptionRejection = 'consumption:rejection',
}

export enum AssetDeliveryStatus {
  SetupIncomplete = 'SetupIncomplete',
  Operational = 'Operational',
  PendingDelivery = 'PendingDelivery'
}

export enum AssetType {
  Solar = 'SolarPvSystem',
  // Generator = 'Generator', // We don't support generators yet.
  Wheeling = 'Wheeling',
}

export const assetTypeDisplayNames = {
  [AssetType.Solar]: 'Solar PV System',
  // [AssetType.Generator]: 'Generator',
  [AssetType.Wheeling]: 'Wheeling'
} as const satisfies Record<AssetType, string>

export enum AssetEscalationType {
  CpiLinked = 'CpiLinked',
  Fixed = 'Fixed',
  UtilityLinked = 'UtilityLinked',
}

export enum AssetSetupFileType {
  ReconciliationData = 'reconciliation:utility-provider-data'
}
export enum contractType {
  ORP = 'Orp',
  PPA = 'Ppa',
  Lease = 'Lease',
  VPPA = 'Vppa'
}

export const contractTypeDisplayNames = {
  [contractType.ORP]: 'ORP',
  [contractType.PPA]: 'PPA',
  [contractType.Lease]: 'Lease',
  [contractType.VPPA]: 'VPPA',
} as const satisfies Record<contractType, string>

export enum VppaType {
  Firm = 'Firm',
  NonFirm = 'NonFirm'
}

export const vppaTypeDisplayNames = {
  [VppaType.Firm]: 'Firm',
  [VppaType.NonFirm]: 'Non-Firm'
} as const satisfies Record<VppaType, string>
